export const SAVE_BEFORE_LOGIN_INFO = 'SAVE_BEFORE_LOGIN_INFO'
export const LOAD_BEFORE_LOGIN_INFO = 'LOAD_BEFORE_LOGIN_INFO'
